<script>
  import { datepicker } from 'vue-strap';
  import formasPagamento from '~js/formas-pagamento';
  import pessoaServico from '~modulos/pessoa/servico';

  export default {
    components: { datepicker },
    props: {
      pedido: {
        type: Object,
        required: true
      },
    },
    data() {
      return {
        configuracao: this.$storage.configuracao(),
        formasPagamento: formasPagamento,
      }
    },
    methods: {
      setarFornecedor() {      
        this.pedido.fornecedores.map(fornecedor => {
          if (fornecedor.idPessoaFisicaJuridica == this.pedido.idFornecedor) {
            this.$set(this.pedido, 'cpfCnpj', fornecedor.cpfCnpj);
            this.$parent.carregarDadosBancarios(fornecedor.cpfCnpj);
            this.pedido.banco = '';
            this.pedido.agencia = '';
            this.pedido.contaCorrente = '';
            this.pedido.tipoConta = '';
          }
        });
      },
      arrayRemove(arr, value) {
         return arr.filter(function(ele){
             return ele.id != value;
         });
      },
      aplicaconfiguracaoweb() {
        if (this.configuracao) {
          // Visualiza��o Formas Pagamento
          if (!this.configuracao.solPgtoDeposito)
            this.formasPagamento = this.arrayRemove(this.formasPagamento, 0);

          if (!this.configuracao.solPgtoCheque)
            this.formasPagamento = this.arrayRemove(this.formasPagamento, 1);

          if (!this.configuracao.solPgtoOP)
            this.formasPagamento = this.arrayRemove(this.formasPagamento, 2);

          if (!this.configuracao.solPgtoBoleto)
            this.formasPagamento = this.arrayRemove(this.formasPagamento, 3);
        }
      },  
      validar(valido) {       
        return this.$validator.validateAll();
      },
    },
    computed: {

    },
    mounted() {
      this.aplicaconfiguracaoweb();
      $('#terminoProjeto input').attr('disabled', '');
      $('#dataPedido input').attr('disabled', '');
    },
  }
</script>

<template>
  <div>
    <div class="row">
      <div class="col-sm-2">
        <div class="form-group">
          <label class="control-label" for="solicitacaoCompra">Solicita&ccedil;&atilde;o compra</label>

          <input type="text"
                 class="form-control"
                 id="solicitacaoCompra"
                 v-model="pedido.idSolicitacaoCompra"
                 disabled>
        </div>
      </div>

      <div class="col-sm-2">
        <div class="form-group">
          <label class="control-label" for="numeroPedido">N&#176; pedido compra</label>

          <input type="text"
                 class="form-control"
                 id="numeroPedido"
                 v-model="pedido.numeroPedidoCompra"
                 disabled>
        </div>
      </div>

      <div class="col-xs-5">
        <div class="form-group">
          <label class="control-label" for="forneceddor">Fornecedor</label>

          <select id="fornecedor"
                  class="form-control"
                  v-model="pedido.idFornecedor"
                  @change="setarFornecedor">
            <option :value="fornecedor.idPessoaFisicaJuridica" v-for="(fornecedor, index) in pedido.fornecedores">{{ fornecedor.nomePessoaFisicaJuridica  }} - {{ fornecedor.cpfCnpj }}</option>
          </select>
        </div>
      </div>

      <div class="col-sm-3">
        <div class="form-group">
          <label class="control-label" for="cnpj">CNPJ</label>

          <input type="text"
                 class="form-control"
                 id="cnpj"
                 v-model="pedido.cpfCnpj"
                 disabled>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-2">
        <div class="form-group">
          <label class="control-label">Data pedido</label>

          <datepicker id="dataPedido"
                      v-model="pedido.dataPedido"
                      format="dd/MM/yyyy"
                      placeholder="  /  /     "
                      lang="pt-BR"
                      data-vv-name="dataPedido"
                      data-vv-as="Data pedido"
                      v-mascara="'data-mask'">
          </datepicker>
        </div>
      </div>

      <div class="col-sm-8">
        <div class="form-group">
          <label class="control-label" for="projeto">Projeto</label>

          <input type="text"
                 class="form-control"
                 id="projeto"
                 v-model="pedido.nomeProjeto"
                 disabled>
        </div>
      </div>

      <div class="col-lg-2">
        <div class="form-group">
          <label class="control-label">T&eacute;rmino projeto</label>

          <datepicker id="terminoProjeto"
                      v-model="pedido.dataPedido"
                      format="dd/MM/yyyy"
                      placeholder="  /  /     "
                      lang="pt-BR"
                      data-vv-name="dataPedido"
                      data-vv-as="Data pedido"
                      v-mascara="'data-mask'">
          </datepicker>
        </div>
      </div>
    </div>

    <div class="row">

      <div class="col-lg-2">
        <div class="form-group required" :class="{'has-error': errors.has('dataEntrega')}">
          <label class="control-label">Data de entrega</label>

          <datepicker id="dataEntrega"
                      v-model="pedido.dataEntrega"
                      format="dd/MM/yyyy"
                      placeholder="  /  /     "
                      lang="pt-BR"
                      data-vv-name="dataEntrega"
                      data-vv-as="Data entrega"
                      v-mascara="'data-mask'"
                      v-validate="'required|date_format:DD/MM/YYYY'">
          </datepicker>

          <p class="text-danger" v-show="errors.has('dataEntrega')">{{ errors.first('dataEntrega') }}</p>
        </div>
      </div>

      <div class="col-lg-2">
        <div class="form-group required" :class="{'has-error': errors.has('dataEmissao')}">
          <label class="control-label">Data emiss&atilde;o NF</label>

          <datepicker id="dataEmissao"
                      v-model="pedido.dataNotaFiscal"
                      format="dd/MM/yyyy"
                      placeholder="  /  /     "
                      lang="pt-BR"
                      data-vv-name="dataEmissao"
                      data-vv-as="Data emissao NF"
                      v-mascara="'data-mask'"
                      v-validate="'required|date_format:DD/MM/YYYY'">
          </datepicker>
        </div>

        <p class="text-danger" v-show="errors.has('dataEmissao')">{{ errors.first('dataEmissao') }}</p>
      </div>

      <div class="col-lg-2">
        <div class="form-group required" :class="{'has-error': errors.has('dataVencimento')}">
          <label class="control-label">Data vencimento</label>

          <datepicker id="dataVencimento"
                      v-model="pedido.dataVencimento"
                      format="dd/MM/yyyy"
                      placeholder="  /  /     "
                      lang="pt-BR"
                      data-vv-name="dataVencimento"
                      data-vv-as="Data vencimento"
                      v-mascara="'data-mask'"
                      v-validate="'required|date_format:DD/MM/YYYY'">
          </datepicker>
        </div>

        <p class="text-danger" v-show="errors.has('dataVencimento')">{{ errors.first('dataVencimento') }}</p>
      </div>

      <div class="col-sm-1">
        <div class="form-group required" :class="{'has-error': errors.has('numeroNF')}">
          <label class="control-label" for="numeroNF">N. nota fiscal</label>

          <input type="text"
                 class="form-control"
                 id="numeroNF"
                 v-validate="'required'"
                 maxlength="20"
                 data-vv-name="numeroNF"
                 data-vv-as="numero nota fiscal"
                 v-model="pedido.numeroNotaFiscal">

          <p class="text-danger" v-show="errors.has('numeroNF')">{{ errors.first('numeroNF') }}</p>
        </div>
      </div>

      <div class="col-lg-1">
        <div class="form-group">
          <label class="control-label" for="desconto">Desconto (R$)</label>

          <input type="text"
                 class="form-control text-right"
                 id="desconto"
                 v-mascara="'moeda'"
                 v-model="pedido.descontoPedido">
        </div>
      </div>

      <div class="col-lg-2">
        <div class="form-group">
          <label class="control-label" for="valorFrete">Frete\acr&eacute;scimo (R$)</label>

          <input type="text"
                 class="form-control text-right"
                 id="valorFrete"
                 v-mascara="'moeda'"
                 v-model="pedido.valorFrete">
        </div>
      </div>

      <div class="form-group required col-sm-2" :class="{'has-error': errors.has('formaPagamento')}">
        <label class="control-label" for="forma-pagamento">Forma de pagamento</label>

        <select class="form-control"
                id="forma-pagamento"
                v-model="pedido.formaPagamento"
                data-vv-name="formaPagamento"
                data-vv-as="forma de pagamento"
                v-validate="'required'">
          <option value="">Selecione...</option>
          <option :value="formaPagamento.id" v-for="formaPagamento in formasPagamento">{{ formaPagamento.nome }}</option>
        </select>

        <p class="text-danger" v-show="errors.has('formaPagamento')">{{ errors.first('formaPagamento') }}</p>
      </div>
    </div>

  </div>

</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/pedido/componentes/compartilhado/FormPedidoDados.vue